export enum FetchPolicy {
  CACHE_FIRST = 'cache-first',
  CACHE_AND_NETWORK = 'cache-and-network',
  NETWORK_ONLY = 'network-only',
  CACHE_ONLY = 'cache-only',
}

const fetchQuery = async <FetchDataResponse>(
  client: any,
  query: any,
  variables: object,
  {
    resultDataPath,
    requestPolicy = FetchPolicy.CACHE_AND_NETWORK,
  }: {
    resultDataPath?: string | null;
    requestPolicy?: FetchPolicy;
  },
) => {
  const response = await client.query(query, variables, { requestPolicy }).toPromise();

  let error,
    data: FetchDataResponse | null = null;
  if (response.error) {
    error = response.error;
    console.log(response.error);
  } else {
    data = response.data;
  }

  return {
    error,
    data,
  };
};

export default fetchQuery;
